import React from "react";
import { useParams } from "react-router-dom";
import "./roadClosureWorkPermitAll.css";

const Template2CS = ({ workDetails }) => {
  console.log("workDetails of rc template 2", workDetails);

  const { formId } = useParams();
  console.log("ID from URL:", formId);

  // 🔹 Safely get first item
  const details = workDetails?.[0] || {};

  const getTextValue = (...values) =>
    values.find(
      (value) =>
        value !== null &&
        value !== undefined &&
        String(value).trim() !== ""
    ) ?? "";

  // 🔹 Helper: Format date and time (UTC → readable format)
  const formatDateTime = (dateString, part) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";

    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return part === "time" ? time : `${day}/${month}/${year}`;
  };

  // 🔹 Issued To Details
  const getIssuedToDetails = () => {
    const issuedTo =
      typeof details.issued_to === "object"
        ? details.issued_to?.value
        : details.issued_to;
    const section = details.section;
    const departmentName = details.department_name;
    const contractor = details.contractor;

    switch (issuedTo) {
      case "Department":
        return departmentName ? `${departmentName} (Department)` : "";
      case "Section":
        return section ? `${section} (Section)` : "";
      case "Contractor":
        return contractor ? `${contractor} (Contractor)` : "";
      default:
        return "";
    }
  };

  // 🔹 Checkbox checked state from work_type string
  const workTypes = Array.isArray(details.work_type_list)
    ? details.work_type_list
    : typeof details.work_type === "string"
    ? details.work_type.split(",").map((t) => t.trim())
    : [];

  const isChecked = (type) => workTypes.includes(type);
  const exactLocation =
    [
      details.area,
      details.unit,
      details.location,
      details.facility_location,
      details.work_location,
      details.TagNos,
    ]
      .filter((value) => value !== null && value !== undefined && `${value}`.trim() !== "")
      .join(" / ") || "";

  return (
    <div className="rc_template-container">
      <div className="section_2_border">
        {/* --- Work Type Checkboxes --- */}
        <div className="rc_checkbox_group">
          <label className="rc_checkbox_item">
            <input
              type="checkbox"
              className="rc_small_checkbox"
              checked={isChecked("Excavation")}
              readOnly
            />
            Excavation
          </label>

          <label className="rc_checkbox_item">
            <input
              type="checkbox"
              className="rc_small_checkbox"
              checked={isChecked("Road Cutting")}
              readOnly
            />
            Road Cutting
          </label>

          <label className="rc_checkbox_item">
            <input
              type="checkbox"
              className="rc_small_checkbox"
              checked={isChecked("Road Closure")}
              readOnly
            />
            Road Closure
          </label>
        </div>

        {/* --- Work Info Section --- */}
        <div className="template-container-pera section_2_pd rc_work-info">
          <div className="rc_work-info-row">
            Work clearance from{" "}
            <span className="work-text">
              {formatDateTime(details.valid_from, "time")}
            </span>
            hrs. of date
            <span className="work-text">
              {formatDateTime(details.valid_from, "date")}
            </span>{" "}
            To{" "}
            <span className="work-text">
              {formatDateTime(details.valid_to, "time")}
            </span>
            hrs. of date
            <span className="work-text">
              {formatDateTime(details.valid_to, "date")}
            </span>
            <span className="rc_work-info-note">
              (valid for the shift unless renewed).
            </span>
          </div>

          <div className="rc_work-info-row">
            Issued to (Department/Section){" "}
            <span className="work-text">{getIssuedToDetails()}</span>
          </div>

          <div className="rc_work-info-row">
            Exact location of work (Area/Unit){" "}
            <span className="work-text">
              {exactLocation}
            </span>
          </div>

          <div className="rc_work-info-row">
            Description of work:{" "}
            <span className="work-text">
              {details.work_description || ""}
            </span>
          </div>

          <div className="rc_work-info-row">
            Details of excavation length{" "}
            <span className="work-text">
              {details.excavation_length ?? ""}
            </span>{" "}
            Mtrs. Width{" "}
            <span className="work-text">
              {details.excavation_width ?? ""}
            </span>{" "}
            Mtrs. Depth{" "}
            <span className="work-text">
              {details.excavation_depth ?? ""}
            </span>
            Mtrs.
          </div>

          <div className="rc_work-info-row">
            Performing Agency (Contractor):{" "}
            <span className="work-text">
              {details.contractor || ""}
            </span>{" "}
            &nbsp; No. of men who will work at site:{" "}
            <span className="work-text">{details.no_of_men ?? ""}</span>
          </div>

          <div className="rc_work-info-row">
            COLD/HOT WORK PERMIT NO{" "}
            <span className="work-text">
              {getTextValue(details.related_permit_no)}
            </span>{" "}
            DATED{" "}
            <span className="work-text">
              {formatDateTime(getTextValue(details.issued_date, details.created_at), "date")}
            </span>{" "}
            TIME (From{" "}
            <span className="work-text">
              {formatDateTime(details.work_time_from, "time")}
            </span>{" "}
            hrs. to{" "}
            <span className="work-text">
              {formatDateTime(details.work_time_to, "time")}
            </span>{" "}
            hrs.)
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template2CS;





// import React from "react";
// import "./roadClosureWorkPermitAll.css";

// import { useParams } from "react-router-dom";

// const Template2CS = ({ workDetails }) => {
//   console.log("workDetails of rc template 2", workDetails);

//   const { formId } = useParams();
//   console.log("ID from URL:", formId);

//   const formatDateTime = (dateString) => {
//     if (!dateString) return "N/A";

//     // Create a Date object from the date string
//     const date = new Date(dateString);

//     // Convert to UTC and format time
//     const time = date.toLocaleTimeString("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//       timeZone: "UTC",
//     });

//     // Format date to DD/MM/YYYY using UTC date methods
//     const day = String(date.getUTCDate()).padStart(2, "0");
//     const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JS
//     const year = date.getUTCFullYear();

//     // Combine to form the date string in DD/MM/YYYY format
//     const dateStr = `${day}/${month}/${year}`;

//     return `${time} बजे, दिनांक /hrs. of date ${dateStr}`;
//   };

//   const getIssuedToDetails = () => {
//     const issuedTo = workDetails[0]?.issued_to;
//     const section = workDetails[0]?.section;
//     const departmentName = workDetails[0]?.department_name; // Assuming department_id exists
//     const contractor = workDetails[0]?.contractor; // Assuming contractor exists

//     switch (issuedTo) {
//       case "Department":
//         return `${departmentName} (Department)`; // department_id followed by "Department"
//       case "Section":
//         return `${section} (Section)`; // section followed by "Section"
//       case "Contractor":
//         return `${contractor} (Contractor)`; // contractor followed by "Contractor"
//       default:
//         return "Not Issued"; // Default case when issued_to is unknown or empty
//     }
//   };

//   return (
//     <>
//       <div className="rc_template-container">
//         <div className=" section_2_border">
          
//             <div className="rc_checkbox_group">
//               <label className="rc_checkbox_item">
//                 <input type="checkbox" className="rc_small_checkbox" />
//                 Excavation
//               </label>

//               <label className="rc_checkbox_item">
//                 <input type="checkbox" className="rc_small_checkbox" />
//                 Road Cutting
//               </label>

//               <label className="rc_checkbox_item">
//                 <input type="checkbox" className="rc_small_checkbox" />
//                 Road Closure
//               </label>
//             </div>
          
//           <div className="template-container-pera section_2_pd">
//             <div className="">
//               Work clearance from{" "}
//               <span className="work-text">
//                 {formatDateTime(workDetails[0]?.valid_from)}
//               </span>{" "}
//               To{" "}
//               <span className="work-text">
//                 {formatDateTime(workDetails[0]?.valid_to)}
//               </span>
//             </div>
//             <div className="">(valid for the shift unless renewed).</div>
//             <div className="">
//               Issued to (Department/Section){" "}
//               <span className="work-text">{getIssuedToDetails()}</span>
//             </div>
//             <div className="">
//               Exact location of work (Area/Unit){" "}
//               <span className="work-text">
//                 {workDetails[0]?.area} / {workDetails[0]?.unit} /{" "}
//                 {workDetails[0]?.TagNos}
//               </span>{" "}
//             </div>
//             <div className="">
//               Description of work:{" "}
//               <span className="work-text">
//                 {workDetails[0]?.work_description || ".................."}
//               </span>
//             </div>
//             <div className="">
//               Details of excavation length
//               <span className="work-text">
//                 {workDetails[0]?.work_description || ".................."} Mtrs.
//               </span>
//               <span className="work-text">
//                 width {workDetails[0]?.work_description || ".................."}{" "}
//                 Mtrs.
//               </span>
//               <span className="work-text">
//                 Depth {workDetails[0]?.work_description || ".................."}{" "}
//                 Mtrs.
//               </span>
//             </div>
//             <div className="">
//               <span className="work-text">
//                 Performing Agency (Contractor){" "}
//                 {workDetails[0]?.work_description || ".................."}
//               </span>
//               <span className="work-text">
//                 No. of men who will work at site{" "}
//                 {workDetails[0]?.work_description || ".................."}
//               </span>
//             </div>

//             <div className="">
//               COLD/HOT WORK PERMIT NO{" "}
//               <span className="work-text">{getIssuedToDetails()}</span>
//               <span className="work-text">
//                 DATED {workDetails[0]?.work_description || ".................."}
//               </span>
//               <span className="work-text">
//                 TIME (From{" "}
//                 {workDetails[0]?.work_description || ".................."} hrs.
//                 to {workDetails[0]?.work_description || ".................."}
//                 hrs.)
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Template2CS;
